import { Actions, ActionTypes } from '../actions/actions-avc-credit-line';
import { initialState, State } from '../states/avc-credit-line-state';

export function reducer(state = initialState, action: Actions): State {
  switch (action.type) {

    case ActionTypes.RequestCreditLineStatus: {
      return {
        ...state,
        creditLineStatusLoading: true
      };
    }

    case ActionTypes.RequestCreditLineStatusSuccess: {
      return {
        ...state,
        creditLineStatus: action.avcCreditLine,
        creditLineStatusLoading: false,
        isError: false
      };
    }

    case ActionTypes.RequestCreditLineStatusError: {
      return {
        ...state,
        isError: true,
        creditLineStatusLoading: false
      };
    }

    default: {
      return state;
    }
  }
}
